import { useEffect } from "react"
import { SvgLogo } from "@/shared/ui/svg"
import { Button } from "@/components/ui/button"
import { useAutoTranslation } from "@/entities"
import { DISCOVERED_TRANSLATION_KEYS } from "@/shared/constants"

// Store URLs
const APP_STORE_URL =
  "https://apps.apple.com/us/app/frateca-text-to-speech-audio/id6741859465"
const PLAY_STORE_URL =
  "https://play.google.com/store/apps/details?id=ai.texttospeech.app"

const detectPlatform = (): "ios" | "android" | "desktop" => {
  const userAgent = navigator.userAgent.toLowerCase()

  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios"
  }
  if (/android/.test(userAgent)) {
    return "android"
  }
  return "desktop"
}

export const AppDownloadPage = () => {
  const { t } = useAutoTranslation()
  useEffect(() => {
    const platform = detectPlatform()

    if (platform === "ios") {
      window.location.href = APP_STORE_URL
    } else if (platform === "android") {
      window.location.href = PLAY_STORE_URL
    }
    // Desktop users stay on the page
  }, [])

  const platform = detectPlatform()

  // Show loading for mobile users while redirecting
  if (platform !== "desktop") {
    return (
      <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-4 p-6">
        <SvgLogo className="h-16 w-16" />
        <p className="text-muted-foreground">
          {t(DISCOVERED_TRANSLATION_KEYS.REDIRECTING_TO_APP_STORE)}
        </p>
      </div>
    )
  }

  // Desktop fallback - show both store options
  return (
    <div className="bg-background flex min-h-screen flex-col items-center justify-center gap-8 p-6">
      <div className="flex flex-col items-center gap-4">
        <SvgLogo className="h-20 w-20" />
        <h1 className="text-3xl font-bold">
          {t(DISCOVERED_TRANSLATION_KEYS.GET_THE_FRATECA_APP)}
        </h1>
        <p className="text-muted-foreground max-w-md text-center">
          {t(
            DISCOVERED_TRANSLATION_KEYS.DOWNLOAD_THE_MOBILE_APP_TO_LISTEN_ON_THE_GO_YOUR_CONTENT_SYNCS_AUTOMATICALLY_ACROSS_ALL_DEVICES
          )}
        </p>
      </div>

      <div className="flex flex-col gap-4 sm:flex-row">
        <Button
          size="lg"
          className="gap-2"
          onClick={() => window.open(APP_STORE_URL, "_blank")}
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
          </svg>
          App Store
        </Button>
        <Button
          size="lg"
          variant="outline"
          className="gap-2"
          onClick={() => window.open(PLAY_STORE_URL, "_blank")}
        >
          <svg viewBox="0 0 24 24" className="h-5 w-5" fill="currentColor">
            <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
          </svg>
          Google Play
        </Button>
      </div>
    </div>
  )
}
